<template>
<div :class="['row', $isDesktop ? 'q-col-gutter-lg' : 'q-col-gutter-md']">
  <div class="col-xs-12 col-sm-4">
    <common-input
        v-model="form.rule_code_letters"
        label="Richtlijncode"
        name="rule_code_letters"
        :error-message="$errorMessage('rule_code_letters')"
        :error="$hasError('rule_code_letters')"
        required
        autofocus
    />
  </div>
  <div class="col-xs-12 col-sm-8">
    <common-input
        v-model="form.title"
        label="Titel"
        name="title"
        :error-message="$errorMessage('title')"
        :error="$hasError('title')"
        required
    />
  </div>
  <div class="col-xs-12 col-sm-8">
    <common-input
        v-model="form.content_owner"
        label="Contenteigenaar/eigenaren"
        name="content_owner"
        :error-message="$errorMessage('content_owner')"
        :error="$hasError('content_owner')"
    />
  </div>
  <div class="col-12">
    <common-input name="description" v-model="form.description" label="Omschrijving" type="textarea"
                  :error-message="$errorMessage('description')"
                  :error="$hasError('description')"
    />
  </div>
  <div class="col-12" v-if="$can('manage-internal-categories')">
    <q-checkbox name="is_internal"
                v-model="form.is_internal"
                label="Categorie is alleen voor intern zichtbaar"
                class="q-mb-md" />
  </div>
</div>
</template>

<script>
export default {
  props: {
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      form: {
        rule_code_letters: this.$old('rule_code_letters', this.category?.rule_code_letters),
        title: this.$old('title', this.category?.title),
        description: this.$old('description', this.category?.description),
        content_owner: this.$old('content_owner', this.category?.content_owner),
        is_internal: this.$old('is_internal', this.category?.is_internal) ?? false
      }
    }
  }
}
</script>
